import inputs from "../../../../../../components/inputs/inputConfigs/fee";

export default timezone => ({
  groups: [
    {
      items: [
        {
          input: inputs.feeBillingTerm,
          grid: { xs: 6 },
        },
        {
          input: { ...inputs.feeBillingDate, timezone },
          grid: { xs: 6 },
        },
      ],
    },
  ],
});
